/** App root admin — ErrorBoundary (lỗi ngoài route) > QueryProvider (server-state) > Router. */
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { QueryProvider, createQueryClient, ErrorBoundary } from "@goppy/ui-kit";
// Khởi tạo i18n (side-effect): đăng ký instance mặc định cho react-i18next (US-AE.F0-0000-S02).
import "../lib/i18n.js";
import { router } from "./router.js";
import { useBootstrapAuth } from "./useBootstrapAuth.js";
import { RouteFallback } from "../components/feedback/RouteFallback.js";
import { ImpersonationBanner } from "../features/impersonation/ImpersonationBanner.js";
import { ImpersonationView } from "../features/impersonation/ImpersonationView.js";
import { ImpersonationTokenProvider } from "../features/impersonation/impersonation-token-context.js";
import { DbEnvProvider } from "../features/db-env/db-env-context.js";
import { DbEnvBanner } from "../features/db-env/DbEnvBanner.js";

const queryClient = createQueryClient();

export function App() {
  // BUG-1: một lần silent refresh lúc boot → khôi phục token in-memory từ refresh cookie trước khi
  // render router (tránh hard-reload/deep-link bị đá về /login oan). ready=false → hiện fallback ngắn.
  const { ready } = useBootstrapAuth();

  return (
    <ErrorBoundary
      onError={(error, info) => {
        // Tối thiểu log ra console để lỗi render production không "mất tích".
        // TODO(E*): nối vào logger có cấu trúc/Sentry khi observability FE sẵn sàng.
        console.error("[admin] render error", error, info.componentStack);
      }}
    >
      <QueryProvider client={queryClient}>
        {/* US-AE11.F3-0039 (@UC9102): token "xem như user" giữ IN-MEMORY (context, không localStorage). */}
        <ImpersonationTokenProvider>
          {/* US-AIF.P0-0247 (@UC9419): env dữ liệu admin (real/sandbox) — persist localStorage, đồng bộ
              store header + invalidate query khi đổi. Bọc trong QueryProvider để dùng queryClient. */}
          <DbEnvProvider>
            {ready ? (
              <>
                {/* Banner cảnh báo bền suốt phiên (chỉ hiện khi active) + panel read-only đọc màn hình user thật. */}
                <ImpersonationBanner />
                {/* @DP-5: banner SANDBOX bền vững — admin không nhầm demo với dữ liệu thật. */}
                <DbEnvBanner />
                <ImpersonationView />
                <RouterProvider router={router} />
              </>
            ) : (
              <RouteFallback />
            )}
          </DbEnvProvider>
        </ImpersonationTokenProvider>
        <Toaster position="top-right" richColors closeButton />
      </QueryProvider>
    </ErrorBoundary>
  );
}
